export { register, themes, CustomLayout, TYPES } from '@visactor/vtable';
